<!--
  ping 테스트 버튼

  @since 2018-10-26
  @author 강정규 ( devp012 )
-->

<template>
  <q-btn @click="onClickPingTest"
         color="primary"
         outline="outline"
         :disable="disable"
         class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line">
    <span v-if="isShow"
          class="q-tooltip animate-popup bs bs-q-tooltip bs-q-tooltip-default bs-q-tooltip-headerProgress top animate-popup-up tooltip-ip-btn">
      <div v-bind:class="messageStyle">{{result}}</div>
    </span>
    <q-icon class="bs-q-btn-icon bs-q-btn-icon-ip-setting-add-sm"></q-icon>
    <!--TAMS-->
    <tool-tip :message="$t('cmn.ping')"></tool-tip>
  </q-btn>
</template>

<script>
  export default {
    name: 'ping-button',
    props: {
      value: {
        type: String,
        default: ''
      },
      authForce: {
        type: Boolean,
        default: false
      },
      disable: {
        type: Boolean,
        default: false
      },
      // TAMS
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        result: '',
        messageStyle: 'bs-q-tooltip-con-group',
        isShow: false,
        isSuccess: false // ping 성공 여부
      }
    },
    methods: {
      async onClickPingTest () {
        this.isSuccess = false
        if (this.value === '') {
          this.$alertPopUp.show(this.$t('msg.needHostAddress'))
          return
        }
        const {code, result} = await this.$axios.$get(`/api/co/tools/connect?target=${encodeURIComponent(this.value)}`)
        if (code === 'ok' && result.connect !== undefined && result.connect) {
          this.messageStyle = 'bs-q-tooltip-con-group txt-succ'
          this.result = this.$tc('cmn.success', 1)
          this.isSuccess = true
        } else {
          this.messageStyle = 'bs-q-tooltip-con-group txt-fail'
          this.result = this.$tc('cmn.fail', 1)

          if (result.msg) {
            // this.$store.state.common.common.components.alertDialog.show(result.msg, 'error')
            this.$alertPopUp.show(result.msg)
          }
        }
        this.isShow = true
        setTimeout(() => {
          this.isShow = false
        }, 1000)
      }
    }
  }
</script>

<style scoped>

</style>
